module.exports = __webpack_public_path__ + "img/training_program_4.2ace7829.jpg";